module.exports = __webpack_public_path__ + "media/shutter.9f994cb1.mp3";